import React from "react";
import PropTypes from "prop-types";

import styles from "./MainApp.organisms.Product.LoadButtons.module.scss";
export class LoadButtons extends React.Component {
  render() {
    const { title, icon, subtitle, handleFunc } = this.props;

    return (
      <div className={styles["load-buttons-container"]} onClick={handleFunc} data-automation-id="load-button">
        <i className={`${styles["icon-load-button"]} ${icon}`}></i>
        <div className={styles["title"]}>{title}</div>
        <div className={styles["subtitle"]}>{subtitle}</div>
      </div>
    );
  }
}

LoadButtons.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  handleFunc: PropTypes.func,
};

export default LoadButtons;
